import React from 'react';
import styled from "@emotion/styled";
import { FormControl, FormControlLabel, FormLabel, Grid, IconButton, Radio, RadioGroup, Tooltip } from "@mui/material";
import { COLOR_MAP } from '../../../../constants/ColorNames';
import RadioButtonGroups from '../../../../common/components/RadioButtonsGroup';
import { INFO_ICON } from '../../../../constants/icons/InfoIcon';
import { CROSS_ICON } from '../../../../constants/icons/CrossIcon';
import { useSelector } from 'react-redux';
import { RootState } from '../../../../redux/store';

// type ProhibitedContentProps = {
//   handleActionsButtonsChange: (event: React.ChangeEvent, value: string) => void;
//   value: string
// }

type TooltipContentProps = {
  handleTooltipVisiblity: (value: boolean) => void;
}

const Container = styled.div`
 
`

const StyledLabel = styled.p`
  font-weight: 500;
  font-size: 1.2rem;
  line-height: 1.6rem;
  color: ${COLOR_MAP.LIGHT_GREY};
  margin: 0;
  margin-bottom: 0.4rem;
`

const InfoContent = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 24px;
`

const ProhibitedInfo = styled.div`
  display: flex;
  align-items: center;
  font-weight: 400;
  font-size: 1.2rem;
  line-height: 1.6rem;
  gap: 4px;
  min-width: 130px;
  color: ${COLOR_MAP.GREY_3};
`
const TimeZone = styled.p`
  font-weight: 400;
  font-size: 1.2rem;
  line-height: 1.6rem;
  margin: 0;
`

const ToolTipContainer = styled(Grid)`
  width: 440px;
  height: 430px;
  padding: 15px 12px 0 12px;
  color: ${COLOR_MAP.WHITE};
  background-color: ${COLOR_MAP.LIGHT_GREY};
  border-radius: 1rem;
  font-weight: 400;
  font-size: 14px;
  line-height: 20px;
`

const TooltipContentHeader = styled.p`
  font-weight: 700;
  font-size: 1.6rem;
  line-height: 2.4rem;
  margin: 0;
`

const TooltipContainerBody = styled.div`
  font-weight: 400;
  font-size: 14px;
  line-height: 20px;
`

const StyledCrossIcon = styled(CROSS_ICON)`
  cursor: pointer;
`

const RadioOptions = [
  { label: 'Reply', value: 'reply' },
  { label: 'Apply', value: 'apply' },
  { label: 'Both', value: 'both' }
]

const ToolTipContent = (props: TooltipContentProps) => {
  const { handleTooltipVisiblity } = props;
  return (
    <ToolTipContainer container spacing={1}>
      <Grid item xs={1}>
        <INFO_ICON fill={COLOR_MAP.WHITE} height={24} width={24} />
      </Grid>
      <Grid item xs={10}>
        <strong>
        Important Guidelines - Prohibited Content:
        </strong>
        <TooltipContainerBody>
          <ul>
            <li>Emails that mention religion, caste, race, or gender.</li>
            <li>Emails requesting money or any form of regular payments from job seekers.</li>
            <li>Emails promoting services like immigration assistance instead of actual job opportunities.</li>
            <li>Emails lacking clear job details, potentially giving an impression of a "fake job."</li>
            <li>Emails containing links to external websites (unless specified in the sales agreement and approved by Compliance).</li>
            <li>Emails promoting products, services, franchise or chain marketing, business opportunities, or training services.</li>
          </ul>
        </TooltipContainerBody>
        <strong>
        Any outreach containing prohibited content will be reviewed and may be blocked
        </strong>
      </Grid>
    </ToolTipContainer>
  )
}

const ProhibitedContent = () => {
  const [showTootlip, setShowTootlip] = React.useState(false);
  // const { handleActionsButtonsChange, value } = props;

  const timeZone = useSelector((state: RootState) => state.campaign.campaignCreationQueryData.timeZone);
  
  const handleTooltipVisiblity = React.useCallback((value: boolean) => {
    setShowTootlip(value);
  }, [])

  return (
    <Container>
      {/* <RadioButtonGroups onChange={handleActionsButtonsChange} value={value} label={<StyledLabel>Add Buttons In Email</StyledLabel>} options={RadioOptions} /> */}
      <InfoContent>
        <Tooltip
          open={showTootlip}
          onOpen={() => handleTooltipVisiblity(true)}
          onClose={() => handleTooltipVisiblity(false)}
          title={<ToolTipContent handleTooltipVisiblity={handleTooltipVisiblity} />} arrow placement="top-end">
          <ProhibitedInfo>
            <INFO_ICON></INFO_ICON>
            Prohibited content
          </ProhibitedInfo>
        </Tooltip>
        {/* <TimeZone>{timeZone}</TimeZone> */}
      </InfoContent>
    </Container>

  )
}

export default ProhibitedContent;
